import { EventIdentifier, TrackingEventType, useAnalytics } from '@capsicum/common';
import { useWalletCurrencies, useWalletFanTokens } from '@capsicum/features/wallet/shared';
import { Regulation, useMe } from '@capsicum/socios-core';
import { useEffect, useRef } from 'react';
import { styled } from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { WalletActionBar } from '../../ui/WalletActionBar';
import { WalletBalance } from '../../ui/WalletBalance';

export const WalletHeaderContent = () => {
	const { data } = useWalletCurrencies();
	const analytics = useAnalytics();

	const { data: fanTokens } = useWalletFanTokens();
	const userId = useMe().me.externalUserId;

	const { altCurrency, defaultCurrency, regulation } = data ?? {};

	const isUsaRegulation = regulation === Regulation.Usa;

	// Use a ref to persist the event sent state across re-renders
	const eventSentRef = useRef(false);

	useEffect(() => {
		if (!eventSentRef.current) {
			analytics.sendEvent(TrackingEventType.track, EventIdentifier.WalletMainPage, {
				device_id: uuidv4(),
				user_id: userId
			});
			eventSentRef.current = true;
		}
	}, [analytics, userId]);

	return (
		<S.WalletHeaderContent>
			<WalletBalance
				altCurrency={altCurrency}
				defaultCurrency={defaultCurrency}
				isUsaRegulation={isUsaRegulation}
			/>
			<WalletActionBar
				defaultCurrency={defaultCurrency}
				isUsaRegulation={isUsaRegulation}
				tokenBalance={fanTokens?.totalBalance?.rawTotalBalanceOfFanTokens}
			/>
		</S.WalletHeaderContent>
	);
};

namespace S {
	export const WalletHeaderContent = styled.section`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;
}
